export const RussianLabels = {
  servicePort: 'Service Port',
  uiPort: 'UI Port',
  smartthingsAppId: 'Smartthings Application Id',
  smartthingsAppSecret: 'Smartthings Application Secret',
  save: 'Сохранить',
  settings: 'Настройки',
  devices: 'Устройства',
  addDevice: 'Добавить Устройство',
  users: 'Пользователи',
  addUser: 'Добавить Пользователя',
  actionId: 'Действие',
  deviceLabel: 'Название устройства',
  cooling10Mins: 'Режим Охлаждения на 10 Мин.',
  cooling20Mins: 'Режим Охлаждения на 20 Мин.',
  cooling30Mins: 'Режим Охлаждения на 30 Мин.',
  windscreen10Mins: 'Обогрев лобового окна на 10 мин.',
  windscreen20Mins: 'Обогрев лобового окна на 20 мин.',
  windscreen30Mins: 'Обогрев лобового окна на 30 мин.',
  heating10Mins: 'Режим Отопителя на 10 мин.',
  heating20Mins: 'Режим Отопителя на 20 мин.',
  heating30Mins: 'Режим Отопителя на 30 мин.',
  airconOn: 'Включить Климат контроль',
  airconOff: 'Отключить Климат Контроль',
  headlightsOn: 'Включить Фары',
  headlightsOff: 'Выключить Фары',
  parkinglightsOn: 'Включить Парковочные огни',
  parkinglightsOff: 'Выключить Парковочные огни',
  username: 'Имя пользователя',
  password: 'Пароль',
  delete: 'Удалить',
  shard: 'Smartthings Portal Shard',
  macAddress: 'MAC адрес',
  keycloakJson: 'Securing Applications using keycloak.json',
  testDevice: 'Протестировать устройство',
  actionTimeout: 'Максимальное время выполнения ',
  language: 'Язык',
  modalHelp: 'Где взять параметр ',
  modalStep1: '1. Откройте портал ',
  modalStep2: '2. Выбрать smartapps в вашей локации ',
  modalStep3: '3. Выберите созданное вами "remote-ctrl-gsm" ',
  modalStep4: '4. Возмите со страницы параметр ',
  modelYear: 'Год Выпуска PHEV',
  any: 'Любой',
  phev2019: '2019',
  battery: 'Заряд Батареи',
  updateValue: 'Обновить Текущее Значение',
  loading: 'Подождите идет загрузка...',
  batteryFactory: 'Множитель батареи',
  doors: 'Статус Открытия/Закрытия Дверей',
  forceUpdate: 'Принудительно обновить модуль',
  executeUpdate: 'Принудительно обновить перед выполнением',
  hvac: 'Текущий режим HVAC',
  sendNotification: 'Отправлять сообщения о состоянии батареи',
  notification: 'Нотификация',
  testNotification: 'Проверить отправку сообщений',
  testNotificationLabel: 'Отправлять Push Уведомления',
  sms: 'SMS Сервис',
  smsPassword: 'SMS Пароль',
  phone: 'Номер мобильного телефона с которого можно слать СМС',
  phoneHuawei: 'Номер мобильного телефона который будет принимать СМС',
  huaweiPassword: 'Huawei Авторизация по паролю (Необязательно)',
  huaweiInstallation: 'Инсталяционный скрипт, пожалуйста запустите от имени root',
  huaweiRecieveSMS: 'Содержимое файла /opt/modem/recieveSMS.sh',
  huaweiSMS: 'Содержимое файла /opt/modem/sendSMS.sh',
  mikrotikScript: 'Mikrotik Script',
  mikrotikScheduler: 'Mikrotik Scheduler',
  smsCommands: 'Список поддержуемых SMS операций',
  smsCar: 'Год Выпуска PHEV в SMS',
  useSmartthings: 'Использовать Smartthings',
  smsCodes: 'SMS Коды Ошибок',
  cron: 'Cron задания',
  sendSMSNotification: 'Отправлять нотификацию через СМС',
  theft: 'Активирована ли штатная охранная система сигнализации в ETACS?',
  Yes: 'Да',
  No: 'Нет',
  useCloud: 'отключена Настройка  "Setup my devices without cloud" в Smartthings Smartapp',
  both: 'Оба типа',
  onlySMS: 'Только СМС',
  onlyPush: 'Только Push',
  none: 'Без нотификации',
  noneSMS: 'Не определено',
  code: 'Код',
  description: 'Описание',
  name: 'Название',
  value: 'Значение',
  role: 'Авторизационная Роль',
  noneRole: 'Без Авторизации',
  logout: 'Выйти',
  evseSlow: 'EVSE Медленая зарядка',
  evseFastCharge: 'EVSE Быстрая зарядка',
  evseDisableCharge: 'EVSE Отключить зарядку ',
  noneUPS: 'Нет',
  ups: 'Источник бесперебойного питания',
  upsMenu: 'ИБП',
  upsInfo: 'Информация от UPS',
  upsMinValue: 'Минимальное значение при котором батарея считается что заряжается',
  UPS2: 'Автоматическое отключение по таймеру',
  upsMaxTimeHours: 'Время до выключения устройства',
  ups1H: '1 Час',
  ups4H: '4 Часа',
  ups5H: '5 Часов',
  ups6H: '6 Часов',
  ups7H: '7 Часов',
  ups8H: '8 Часов',
  ups1D: '1 день',
  ups2D: '2 дня',
  gpioMenu: 'GPIO',
  reboot: 'Перезапустить устройство',
  halt: 'Выключить устройство',
  upgrade: 'Обновить приложение smartthings phevctl',
  shutdown2H: 'Отключение устройство через 2 часа после включения ',
  shutdown5H: 'Отключение устройство через 5 часов после включения',
  shutdown8H: 'Отключение устройство через 8 часов после включения',
  shutdown1D: 'Отключение устройство через 1 день после включения',
  shutdown2D: 'Отключение устройство через 2 дня после включения',
};
